// Création de l'objet à envoyer au back
const formaterCreationIdentite = async (dataForm, uuidBrouillon) => {
    let isAncienLicencieTir;
    let isAncienLicencieSki;
    let isAncienLicencieBallTrap;

    switch (dataForm.selectLicencieOrAncienLicencieTir) {
        case 'isAncienLicencie':
            isAncienLicencieTir = true;
            break;
        case 'isLicencie':
            isAncienLicencieTir = false;
            break;
        default:
            isAncienLicencieTir = null;
    }
    switch (dataForm.selectLicencieOrAncienLicencieSki) {
        case 'isAncienLicencie':
            isAncienLicencieSki = true;
            break;
        case 'isLicencie':
            isAncienLicencieSki = false;
            break;
        default:
            isAncienLicencieSki = null;
    }
    switch (dataForm.selectLicencieOrAncienLicencieBallTrap) {
        case 'isAncienLicencie':
            isAncienLicencieBallTrap = true;
            break;
        case 'isLicencie':
            isAncienLicencieBallTrap = false;
            break;
        default:
            isAncienLicencieBallTrap = null;
    }

    return {
        uuidBrouillon,
        dateNaissance: dataForm.dateNaissance,
        dateDelivrance: dataForm.dateDelivrance,
        lieuNaissance: dataForm.lieuNaissance,
        idNationalite: dataForm.nationalite,
        idPaysNaissance: dataForm.paysNaissance ? dataForm.paysNaissance : 75,
        codeDepartementNaissance: dataForm.departementNaissance,
        nom: dataForm.nom,
        nomUsage: dataForm.nomUsage ? dataForm.nomUsage : dataForm.nom,
        numeroPermisChasseur: dataForm.numeroPermisChasseur,
        licenceTir: {
            isAncienLicencie: isAncienLicencieTir,
            numero: dataForm.numeroLicenceTir ?? '',
        },
        licenceSki: {
            isAncienLicencie: isAncienLicencieSki,
            numero: dataForm.numeroLicenceSki ?? '',
        },
        licenceBallTrap: {
            isAncienLicencie: isAncienLicencieBallTrap,
            numero: dataForm.numeroLicenceBallTrap ?? '',
        },
        prenomUn: dataForm.prenomUn,
        prenomDeux: dataForm.prenomDeux ? dataForm.prenomDeux : null,
        prenomTrois: dataForm.prenomTrois ? dataForm.prenomTrois : null,
        prenomQuatre: dataForm.prenomQuatre ? dataForm.prenomQuatre : null,
        prenomUsuel: dataForm.prenomUsuel ? dataForm.prenomUsuel : dataForm.prenomUn,
        sexe: dataForm.sexe,
        numeroPieceIdentite: dataForm.numeroPieceIdentite,
        typePieceIdentite: dataForm.typePieceIdentite,
        numeroGuichetUnique: dataForm.numeroGuichetUnique,
        numeroSia: dataForm.numeroSia,
    };
};

export default formaterCreationIdentite;
